import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { deleteOrder } from '../../../api/orders';
import AwaitButton from "../../../reusable-components/await-button/AwaitButton";
import { useSnackbar } from '../../../reusable-components/snackbar';

DeleteOrderModal.propTypes = {
  content: PropTypes.node,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  action: PropTypes.func,
  openConfirm: PropTypes.bool,
  setOpenConfirm: PropTypes.func,
};

export default function DeleteOrderModal({
    content,
    rowId,
    action,
    openConfirm,
    setOpenConfirm,
    ...other
}) {

    const { enqueueSnackbar } = useSnackbar();

    const [reason, setReason] = useState('');

    const handleCloseConfirm = () => {
      setOpenConfirm(false);
    };

    const handleAction = () => {
      handleDelete(rowId);
      setOpenConfirm(false);
    };

    const handleDelete = async () => {
      deleteOrder(rowId, reason)
        .then(res => {
          if (res.data) {
            enqueueSnackbar('Order deleted successfully', { variant: 'success' });
            action();
          }
          else enqueueSnackbar('Failed to delete order', { variant: 'error' });
        })
        .catch(() => enqueueSnackbar('Something went wrong', { variant: 'error' }));
    };


    return (
      <Dialog fullWidth maxWidth="xs" open={openConfirm} onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleCloseConfirm();
      }} {...other}>
        <DialogTitle sx={{ pb: 1 }}>Delete</DialogTitle>
        {content && <DialogContent>
          <Typography sx={{ typography: 'body2' }}>
            {content}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>Reason</Typography>
          <TextField
            value={reason}
            minRows={2}
            onChange={(event) => setReason(event.target.value)}
            size="small"
            multiline
            fullWidth
            autoComplete="off"
          />
        </DialogContent>}
        <DialogActions>
          <AwaitButton
            variant="contained"
            color={'error'}
            onClick={handleAction}
          >
            Delete
          </AwaitButton>
          <Button variant="outlined" color="inherit" onClick={handleCloseConfirm}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
}
